/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormik} from "formik";
import {useDispatch, useSelector,} from "react-redux";
import {notification} from "@/store/modules/notification.ts";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {BaseInput} from "../input/BaseInput";
import {RootState} from "@/store/modules";
import {application} from "@/store/modules/application.ts";
import {DeleteApplication, DeleteApplicationInit} from "@/model/request/application/deleteApplication.ts";
import {BaseModal} from "@/components/modal/BaseModal.tsx";
import {base} from "@/store/modules/base.ts";


export default function DeleteApplicationModal() {
    const dispatch = useDispatch<any>();
    const ApplicationState = useSelector((state: RootState) => state.application)
    const workspaceState = useSelector((state: RootState) => state.workspace)
    const baseState = useSelector((state: RootState) => state.base)
    const onClose = () => {
        dispatch(base.mutation.resetModalOptions)
    }
    const data = baseState.modalOptions.payload
    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() => {
            dispatch(application.action.readByWorkspaceId({applicationWorkspaceId: workspaceState?.selectedWorkspace?.workspaceId}))
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
        })
        dispatch(base.mutation.resetModalOptions())
    };
    const handleSubmit = async (value: DeleteApplication) => {
        const request = {
            ...value,
            applicationId: ApplicationState.selectedApplication?.applicationId ? ApplicationState.selectedApplication?.applicationId : 0,
        };
        await dispatch(
            application.action.deleteApplication({
                data: request,
                onSuccess: (response: any) => {
                    showSuccessMessage(response)
                },
                onError: (response: any) => showErrorMessage(response),
            })
        )
        formik.resetForm();
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: DeleteApplicationInit,
    });
    return (

        <BaseModal title={`Delete ${data?.applicationName}`} size={"sm"} subtitle={"Delete this application?"}>
            <div className="workspace-content">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex btns">
                        <a className="button is-secondary w-button"
                           onClick={() => dispatch(base.mutation.resetModalOptions())}>Cancel</a>
                        <BaseInput
                            type="submit"
                            formik={formik}
                            name={"submit"}
                            value={"Yes, Delete"}
                            loading={ApplicationState.loading}
                            className={"button w-button"}
                        />
                    </div>
                </form>
            </div>
        </BaseModal>

    );
}



